export const transformDataTestProperties = ({
  propertyDefinitions,
  propertyMatchRates
}) => {
  const combinedProperties = Object.keys(propertyMatchRates).map(key => {
    return Object.assign({}, propertyMatchRates[key], propertyDefinitions[key]);
  });
  return combinedProperties.sort((a, b) => b.percent - a.percent);
};
export const transformPerformDataTest = payload => {
  const properties = payload.perPropertyData;
  const metadata = payload.reportMetadata;
  return {
    propertyMatchRates: properties,
    recordsEligible: metadata.eligibleCount,
    recordsEligiblePercent: metadata.eligiblePercent,
    recordsEnrichable: metadata.enrichableCount,
    recordsEnrichablePercent: metadata.enrichablePercent,
    recordsIneligible: metadata.ineligibleCount,
    recordsIneligiblePercent: metadata.ineligiblePercent
  };
};